import { render, staticRenderFns } from "./TheSingle.vue?vue&type=template&id=1a3374de&"
import script from "./TheSingle.vue?vue&type=script&lang=js&"
export * from "./TheSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports